import React from "react";
import styled from "styled-components";
import {Table as BsTable} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import {RUTA_PRODUCTOS} from "../../../services/rutas";
import {ItemListadoProductos} from "../../../services/productosServicios";


function Table({items, puedeEditar}: TableSectionProps) {
    return (
        <StyledTable responsive hover>
            <thead>
            <tr>
                <StyledColHeader>Nombre</StyledColHeader>
                <StyledColHeader>Unidad</StyledColHeader>
                <StyledColHeader>Precio Unitario</StyledColHeader>
                <StyledColHeader>Descripción</StyledColHeader>
            </tr>
            </thead>
            <tbody>
            {
                items.map((_, index) => <TableItem key={_.id} item={_} puedeEditar={puedeEditar}/>)
            }
            </tbody>
        </StyledTable>
    );
}

interface TableSectionProps {
    items: ItemListadoProductos[];
    puedeEditar: boolean;
}

interface TableItemProps {
    item: ItemListadoProductos;
    puedeEditar: boolean;
}

function TableItem({item, puedeEditar}: TableItemProps) {
    let navigate = useNavigate();
    const currencyFormat = new Intl.NumberFormat('es-CO', currencyFormatOptions);

    const onRowClick = () => {
      navigate(`${RUTA_PRODUCTOS}/${item.id}`, {replace: false});
    };

    return (
        <StyledRow onClick={onRowClick} $clickable={true}>
            <StyledCell>{item.nombre}</StyledCell>
            <StyledCell>{item.unidad}</StyledCell>
            <StyledCell>{currencyFormat.format(item.precioUnitario)}</StyledCell>
            <StyledCell>{item.descripcion}</StyledCell>
        </StyledRow>
    );
}

const currencyFormatOptions: any = {style: 'currency', currency: 'COP'}

const StyledTable = styled(BsTable)`

`

const StyledCell = styled("td")`

`

const StyledColHeader = styled("th")`
  color: ${props => props.theme.colors.main};
`

const StyledRow = styled("tr")<{ $clickable?: boolean }>`
  cursor: ${props => props.$clickable ? "pointer" : "default"};
`

export default Table;